// extracted by mini-css-extract-plugin
export default {"Heading":"MyInfo_Heading__O6vjn"};